const styles = {
    container: {
        borderRight: '2px solid hsla(200, 6%, 50%, 0.25)',
    },
};

export default styles;
